import React from "react";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { I18n } from "react-redux-i18n";
import "../../../../styles/components/account/manageAccount/ManageUsers.scss";

const EditUserForm = ({
  validated,
  handleOnSubmit,
  name,
  handleInputChange,
  email,
  phone,
  handlePhoneChange,
  country,
  isPhoneNumberValid,
  isEmailValid,
  isNameValid,
}) => {
  return (
    <Form
      id="edit-user-form"
      noValidate
      validated={validated}
      onSubmit={handleOnSubmit}
    >
      <Form.Group controlId="name">
        <Form.Label>
          {I18n.t("manageUsers_name")}
          <span className="required-field">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={name}
          onChange={handleInputChange}
          required
          isInvalid={!isNameValid()}
        />
        <Form.Control.Feedback type="invalid">
          {I18n.t("backOffice_network_forms_invalid_name")}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="email">
        <Form.Label>
          {I18n.t("manageUsers_email")}
          <span className="required-field">*</span>
        </Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={email}
          onChange={handleInputChange}
          required
          isInvalid={!isEmailValid()}
        />
        <Form.Control.Feedback type="invalid">
          {I18n.t("componentVerificationEmail_invalidEmail")}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="phone">
        <Form.Label>
          {I18n.t("manageUsers_mobile")}
          <span className="required-field">*</span>
        </Form.Label>
        <PhoneInput
          value={phone}
          onChange={handlePhoneChange}
          country={country}
          countryCodeEditable={false}
          inputProps={{
            name: "phone",
            required: true,
            autoFocus: true,
            placeholder: country === "pt" && "(351) 919 999 999",
          }}
        />
        <Form.Control.Feedback
          type="invalid"
          style={{ display: !isPhoneNumberValid() ? "block" : "none" }}
        >
          {!isPhoneNumberValid() &&
            I18n.t("backOffice_network_forms_invalid_phone")}
        </Form.Control.Feedback>
      </Form.Group>
      <p>
        <span className="required-field">
          * {I18n.t("manageUsers_requiredFields")}
        </span>
      </p>
    </Form>
  );
};

export default EditUserForm;
